import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Row, Col } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
import { isEmpty } from 'lodash';
import StringHelper from '../helpers/StringHelper';
import { useNonePersistedStore } from '../../store/non-persisted-store';
import { usePersistedStore } from '../../store/persisted-store';

export default function CompanyDefaultWageForm({ onSubmit }) {
    const { wages, getCompanyBranch, addCompanyDefaultAgentWage } = useNonePersistedStore();
    const { users } = usePersistedStore()
    const [form] = Form.useForm();
    const loading = users.loading;
    const companyBrnachs = wages.companyBranch;

    const [branches, setBranches] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState([]);

    let companies = [];

    function onFinish(values) {
        const params = {
            CompanyBranchId: selectedBranch,
            DefaultAgentWagePercent: parseFloat(StringHelper.getEnglishNum(values.DefaultAgentWagePercent)),
            DefaultAgentWagePrice: Number(values.DefaultAgentWagePrice)
        };
        addCompanyDefaultAgentWage({ params: params, cb: onSubmit, reset: () => form.resetFields() })
    }

    useEffect(() => {
        getCompanyBranch()
    }, [])

    if (companyBrnachs && companyBrnachs.length) {
        companies = companyBrnachs.map(item => {
            return { id: item.CompanyId, title: item.CompanyName }
        });
    }

    function getBranches(companyId) {
        const company = companyBrnachs.filter(item => item.CompanyId === companyId)[0];
        if (company && company.Branches && company.Branches.length)
            setBranches(company.Branches.map(item => {
                return { CompanyBranchId: item.CompanyBranchId, BranchName: item.BranchName }
            }));
        onReset()
    }

    const onReset = () => {
        form.resetFields(['Branch']);
    };

    const formLayout = {
        labelCol: {
            lg: 6,
            xs: 24
        },
        wrapperCol: {
            lg: 16,
            xs: 24
        }
    }
    const itemLayout = {
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
    }

    return (
        <Form
            form={form}
            name="user-form"
            className='business-form'
            {...formLayout}
            onFinish={onFinish}>
            <Row>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.required('شرکت')}
                        name="CompanyId"
                        label="شرکت">
                        <Select onChange={(e) => getBranches(e)}>
                            {companies && companies.length && companies.map((company, index) =>
                                <Select.Option key={index} value={company.id}>
                                    {company.title}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={ValidatorHelper.required('رشته بیمه')}
                        name="CompanyBranchId"
                        label="رشته بیمه">
                        <Select disabled={isEmpty(branches)} onChange={(e) => setSelectedBranch(e)}>
                            {branches && branches.length && branches.map((branch, index) =>
                                <Select.Option key={index} value={branch.CompanyBranchId}>
                                    {branch.BranchName}
                                </Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.decimalNumber('درصد کارمزد')
                        ]}
                        name="DefaultAgentWagePercent"
                        label="درصد کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
                <Col {...itemLayout}>
                    <Form.Item
                        rules={[
                            ...ValidatorHelper.number('مبلغ کارمزد')
                        ]}
                        name="DefaultAgentWagePrice"
                        label="مبلغ کارمزد">
                        <Input />
                    </Form.Item>
                </Col>
            </Row>
            <button type="primary" className="btn btn-primary waves-effect waves-light" htmltype="submit" style={{ width: "100%" }}>
                <i className={`${loading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle mr-2 ml-3"`}></i>ثبت
            </button>
        </Form >
    )
}
